var map = {
	"./bleank.png": "./app/assets/images/competitions/digital_art/partners/bleank.png",
	"./boris_fx.png": "./app/assets/images/competitions/digital_art/partners/boris_fx.png",
	"./celsys.png": "./app/assets/images/competitions/digital_art/partners/celsys.png",
	"./escape_motions.png": "./app/assets/images/competitions/digital_art/partners/escape_motions.png",
	"./fanurio_time_tracking.png": "./app/assets/images/competitions/digital_art/partners/fanurio_time_tracking.png",
	"./huion.png": "./app/assets/images/competitions/digital_art/partners/huion.png",
	"./lightwell.png": "./app/assets/images/competitions/digital_art/partners/lightwell.png",
	"./marmoset.png": "./app/assets/images/competitions/digital_art/partners/marmoset.png",
	"./media/80level.png": "./app/assets/images/competitions/digital_art/partners/media/80level.png",
	"./media/andy_sowards.png": "./app/assets/images/competitions/digital_art/partners/media/andy_sowards.png",
	"./media/concept_art_world.png": "./app/assets/images/competitions/digital_art/partners/media/concept_art_world.png",
	"./media/freeyork.png": "./app/assets/images/competitions/digital_art/partners/media/freeyork.png",
	"./nevercenter.png": "./app/assets/images/competitions/digital_art/partners/nevercenter.png",
	"./paintable.png": "./app/assets/images/competitions/digital_art/partners/paintable.png",
	"./pencilkings.png": "./app/assets/images/competitions/digital_art/partners/pencilkings.png",
	"./stash_magazine.png": "./app/assets/images/competitions/digital_art/partners/stash_magazine.png",
	"./tonytextures.png": "./app/assets/images/competitions/digital_art/partners/tonytextures.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images/competitions/digital_art/partners sync recursive ^\\.\\/.*\\.png$";